import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import {
    CLOSE_BUTTON_TEST_ID,
    CLOSE_LABEL,
    COORDINATE_PRECISION,
    EYEBROW_LABEL,
    EYEBROW_TEST_ID,
    REGION_TEST_ID,
    TEST_ID,
    TITLE_TEST_ID
} from './constants';
import type { FunctionComponent, Point, Props } from './types';

import styles from './styles.module.scss';

const formatCoordinates = ({ lat, lng }: Point): string =>
    `${lat.toFixed(COORDINATE_PRECISION)}, ${lng.toFixed(COORDINATE_PRECISION)}`;

const SheetHeader: FunctionComponent<Props> = ({
    address,
    className = '',
    dragHandleRef,
    onClose,
    point,
    region,
    testId = TEST_ID
}) => {
    const coordinates = formatCoordinates(point);
    const hasAddress = address !== null;
    const title = hasAddress ? address : coordinates;
    const showRegion = hasAddress && region !== null;

    return (
        <VerticalContainer className={`${styles.header} ${className}`} testId={testId}>
            <Wrapper className={styles.dragHandle} ref={dragHandleRef} />

            <HorizontalContainer className={styles.titleRow}>
                <VerticalContainer className={styles.titleGroup}>
                    <Wrapper className={styles.eyebrow} testId={EYEBROW_TEST_ID}>
                        {EYEBROW_LABEL}
                    </Wrapper>

                    <Wrapper className={styles.title} testId={TITLE_TEST_ID}>
                        {title}
                    </Wrapper>

                    {showRegion ? (
                        <Wrapper className={styles.region} testId={REGION_TEST_ID}>
                            {region}
                        </Wrapper>
                    ) : null}
                </VerticalContainer>

                <button
                    aria-label={CLOSE_LABEL}
                    className={styles.closeButton}
                    data-testid={CLOSE_BUTTON_TEST_ID}
                    onClick={onClose}
                    type='button'>
                    <svg
                        className={styles.closeIcon}
                        fill='none'
                        height='18'
                        viewBox='0 0 18 18'
                        width='18'
                        xmlns='http://www.w3.org/2000/svg'>
                        <line
                            stroke='currentColor'
                            strokeLinecap='round'
                            strokeWidth='2'
                            x1='3'
                            x2='15'
                            y1='3'
                            y2='15'
                        />

                        <line
                            stroke='currentColor'
                            strokeLinecap='round'
                            strokeWidth='2'
                            x1='15'
                            x2='3'
                            y1='3'
                            y2='15'
                        />
                    </svg>
                </button>
            </HorizontalContainer>
        </VerticalContainer>
    );
};

export default SheetHeader;
